import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Footer } from "@genie-ui/react";
import { Constants } from "@constants";
import "./app.scss";
import FooterTop from "./FooterTop";
import { useEffect, useState } from "react";
import {
  createStateSubscription,
  destroyStateSubscription,
} from "@gartner/genie-messenger-util";

const App = ({
  footerTopData = [],
  loginKey
}) => {
  const [currentUser, setCurrentUser] = useState();

  useEffect(() => {
    const subscriptionLoginDetails = createStateSubscription(
      loginKey,
      (data) => {
        setCurrentUser(data);
      }
    );

    return () => {
      destroyStateSubscription(subscriptionLoginDetails);
    };
  }, []);
  if (!currentUser) {
    return null;
  }

  return (
    <div className="genie-footer__border ">
      <BrowserRouter basename={Constants.ROUTES.BASE_URL}>
        <FooterTop
          footerTopData={footerTopData}
        />
        <Footer
          links={Constants.FOOTER_LINKS}
          hideDownloadApp
          classes={{
            root: "genie-footer__root",
            linksContainer: "genie-footer__layout",
          }}
        />
      </BrowserRouter>
    </div>
  );
};

export default App;
